/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface UpdateSeatEnforcementRequest {
    requestBody: { [key: string]: string; };
}

/**
 * ProductizationSettingsAdminApi - interface
 * 
 * @export
 * @interface ProductizationSettingsAdminApiInterface
 */
export interface ProductizationSettingsAdminApiInterface {
    /**
     * 
     * @summary Get productization settings for Feature Licensing admin UI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductizationSettingsAdminApiInterface
     */
    getSettings1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get productization settings for Feature Licensing admin UI
     */
    getSettings1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Update global seat enforcement policy (PER_USER features)
     * @param {{ [key: string]: string; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductizationSettingsAdminApiInterface
     */
    updateSeatEnforcementRaw(requestParameters: UpdateSeatEnforcementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update global seat enforcement policy (PER_USER features)
     */
    updateSeatEnforcement(requestParameters: UpdateSeatEnforcementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class ProductizationSettingsAdminApi extends runtime.BaseAPI implements ProductizationSettingsAdminApiInterface {

    /**
     * Get productization settings for Feature Licensing admin UI
     */
    async getSettings1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/productization/settings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get productization settings for Feature Licensing admin UI
     */
    async getSettings1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSettings1Raw(initOverrides);
        return await response.value();
    }

    /**
     * Update global seat enforcement policy (PER_USER features)
     */
    async updateSeatEnforcementRaw(requestParameters: UpdateSeatEnforcementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateSeatEnforcement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/productization/settings/seat-enforcement`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update global seat enforcement policy (PER_USER features)
     */
    async updateSeatEnforcement(requestParameters: UpdateSeatEnforcementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateSeatEnforcementRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
